import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate, useParams, Link } from "react-router-dom";

const styles = {
    page: {
        minHeight: "100vh",
        background: "linear-gradient(135deg, #0b0f14, #0a0a0c)",
        color: "#e7e7e9",
        padding: "48px 16px 72px",
        fontFamily: "'Pretendard', 'Noto Sans KR', system-ui, -apple-system, sans-serif",
        boxSizing: "border-box",
    },
    container: {
        maxWidth: "860px",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
    },
    card: {
        background: "rgba(255,255,255,0.04)",
        border: "1px solid rgba(255,255,255,0.07)",
        boxShadow: "0 20px 40px rgba(0,0,0,0.32)",
        borderRadius: "16px",
        padding: "22px 20px",
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "12px",
    },
    title: {
        margin: 0,
        fontSize: "26px",
        fontWeight: 800,
        color: "#ef4444",
        letterSpacing: "-0.02em",
    },
    date: {
        color: "#cbd5e1",
        fontSize: "13px",
        margin: "0 0 12px",
    },
    content: {
        whiteSpace: "pre-wrap",
        lineHeight: 1.7,
        color: "#f8fafc",
        fontSize: "15px",
    },
    footer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: "14px",
    },
    ghostLink: {
        color: "#fb923c",
        fontWeight: 700,
        textDecoration: "none",
    },
    dangerBtn: {
        padding: "10px 14px",
        borderRadius: "12px",
        border: "1px solid rgba(255,255,255,0.12)",
        background: "linear-gradient(120deg, #ef4444, #f97316)",
        color: "#130903",
        fontWeight: 800,
        cursor: "pointer",
        boxShadow: "0 10px 24px rgba(239,68,68,0.28)",
    },
};

const NoticeDetail = () => {
    const { id } = useParams();
    const [cookies] = useCookies(["uuid"]);
    const [notice, setNotice] = useState(null);
    const [superUser, setSuperUser] = useState(0); // 기본값: 일반 사용자
    const navigate = useNavigate();

    useEffect(() => {
        // ✅ 공지사항 상세 불러오기
        fetch(`/notice/${id}`)
            .then((res) => res.json())
            .then((data) => setNotice(data))
            .catch((err) => console.error("공지사항 상세 불러오기 오류:", err));
    }, [id]);

    useEffect(() => {
        // ✅ 관리자 여부 확인
        const uuid = cookies.uuid;
        if (uuid) {
            fetch(`/SetPage/admin_user?uuid=${uuid}`)
                .then((res) => {
                    if (!res.ok) throw new Error("서버 응답 실패");
                    return res.json();
                })
                .then((data) => {
                    const user = data[0];
                    if (user && (user.super_user === 1 || user.super_user === "1")) {
                        setSuperUser(1);
                    }
                })
                .catch((err) => console.error("관리자 정보 확인 오류:", err));
        }
    }, [cookies]);

    if (!notice) return <p style={{ color: "#e7e7e9", textAlign: "center" }}>로딩 중...</p>;

    const handleDelete = async () => {
        if (!window.confirm("정말 삭제하시겠습니까?")) return;

        try {
        const res = await fetch("/notice_delete", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id, uuid: cookies.uuid }),
        });

        const data = await res.json();

        if (res.ok && data.success) {
            alert("공지사항이 삭제되었습니다.");
            navigate("/Notices");
        } else {
            alert(data.error || "삭제 중 오류가 발생했습니다.");
        }
        } catch (err) {
        console.error(err);
        alert("서버와의 통신 오류가 발생했습니다.");
        }
    };
    
    return (
        <div style={styles.page}>
            <div style={styles.container}>
                <div style={styles.card}>
                    <div style={styles.header}>
                        <h1 style={styles.title}>{notice.title}</h1>
                    </div>
                    <p style={styles.date}>
                        {new Date(notice.created_at).toISOString().split("T")[0]}
                    </p>

                    <div style={styles.content}>{notice.content}</div>

                    <div style={styles.footer}>
                        <Link to="/Notices" style={styles.ghostLink}>
                            ← 목록으로
                        </Link>
                        {superUser === 1 && (
                            <button style={styles.dangerBtn} onClick={handleDelete}>
                                글 삭제
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NoticeDetail;
